import React, { memo } from 'react';
import ReactSelect, { components, ControlProps } from 'react-select';
import styled from 'styled-components';
import { ReactSelectChangeEvent, ReactSelectOption } from '../types';
const { Control } = components;

interface Props {
    options: ReactSelectOption[];
    isLoading?: boolean;
    isDisabled?: boolean;
    onChange: ReactSelectChangeEvent;
    placeholder?: string;
    label?: string;
    name?: string;
    selectedOption?: ReactSelectOption;
}

export const controlStyles = {
    border: '1px solid #D2D2D2',
    boxShadow: 'none',
    '&:hover': {
        border: '1px solid #D2D2D2',
        boxShadow: 'none',
        cursor: 'pointer',
    },
};

function Select({
    options,
    isLoading = false,
    isDisabled = isLoading,
    label,
    onChange,
    placeholder,
    name,
    selectedOption,
}: Props) {
    const ControlLabel: React.FC<ControlProps<any>> = (props): JSX.Element | null =>
        label ? (
            <div>
                <Label>{label}</Label>
                <Control {...props} />
            </div>
        ) : null;

    // very annoying, can't conditionally pass Control for label
    return label ? (
        <ReactSelect
            name={name}
            className="basic-single"
            classNamePrefix="select"
            defaultValue={placeholder ? undefined : options[0]}
            value={placeholder ? null : selectedOption}
            options={options}
            placeholder={placeholder}
            components={{ Control: ControlLabel }}
            isLoading={isLoading}
            menuPortalTarget={document.body}
            onChange={onChange}
            isDisabled={isDisabled}
            isSearchable={true}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                container: base => ({ ...base, flex: 1, transitionDuration: '200ms' }),
                control: base => ({
                    ...base,
                    ...controlStyles,
                }),
                option: base => ({ ...base, '&:hover': { cursor: 'pointer' } }),
            }}
        />
    ) : (
        <ReactSelect
            name={name}
            className="basic-single"
            classNamePrefix="select"
            defaultValue={placeholder ? undefined : options[0]}
            value={placeholder ? null : selectedOption}
            options={options}
            placeholder={placeholder}
            menuPortalTarget={document.body}
            isLoading={isLoading}
            onChange={onChange}
            isDisabled={isDisabled}
            isSearchable={true}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                container: base => ({ ...base, flex: 1, transitionDuration: '200ms' }),
                control: base => ({
                    ...base,
                    ...controlStyles,
                }),
                option: base => ({ ...base, '&:hover': { cursor: 'pointer' } }),
            }}
        />
    );
}

export default memo(Select);

const Label = styled.label`
    font-size: 16px;
    font-weight: 600;
    color: #4a5569;
`;
